module.exports = require('./helpers/bundle-url').getBundleURL('ldLGp') + "logo.c51670a8.svg";